import React from 'react'

export default function CTA({ fadeClass = '' }) {
  return (
    <section className={`final-cta-section ${fadeClass}`}>
      <div className="container text-center">
        <span className="eyebrow" style={{ color: 'var(--color-accent-light)' }}>Take Action Today</span>
        <h2 className="cta-text" style={{ marginTop: '0.5rem', marginBottom: '1rem' }}>
          Help Us Shape the Future<br />
          <span>One Child at a Time</span>
        </h2>
        <p className="lead">
          Your support gives children access to structured football development,
          quality education, and the confidence to succeed in life.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap', marginTop: '2rem' }}>
          <a href="/donate" className="btn btn-accent btn-lg">
            <i className="bi bi-heart-fill"></i> Donate Today
          </a>
          <a href="/get-involved" className="btn btn-outline btn-lg">Get Involved</a>
        </div>
      </div>
    </section>
  )
}
